import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p417380092252925952',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})
